/**
 * The modifier a shortcut hint names (spec 129 FR-012): ⌘ on a Mac, Ctrl
 * elsewhere. The topbar said ⌘K to everyone.
 */
export function isMacPlatform(platform: string = navigator.platform): boolean {
  return /mac|iphone|ipad|ipod/i.test(platform);
}

export function modKey(platform?: string): string {
  return isMacPlatform(platform) ? '⌘' : 'Ctrl';
}
